<form
  class="login-form"
  novalidate
  [formGroup]="loginForm"
  (ngSubmit)="onSubmit($event)"
  >
  <div layout="column">
    <mat-form-field>
      <input
        type="email"
        required
        name="email"
        matInput
        formControlName="username"
        placeholder="{{ 'global.email' | translate }}"
        />
        <mat-label>{{ 'global.email' | translate }}</mat-label>
        @if (loginForm.get('username').hasError('required')) {
          <mat-error [translate]="'forms.required'"></mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <input
          #passwordInput
          [readonly]="showForgotPassword"
          type="password"
          required
          name="password"
          matInput
          formControlName="password"
          placeholder="{{ 'global.password' | translate }}"
          (keydown)="onPasswordKeydown($event)"
          (input)="onPasswordInput($event)"
          (paste)="onPasswordPaste()"
          />
          <mat-label>{{ 'global.password' | translate }}</mat-label>
          @if (loginForm.get('password').hasError('required')) {
            <mat-error [translate]="'forms.required'"></mat-error>
          }
          <button matSuffix
            tabindex="-1"
            mat-icon-button
            [itfgTogglePasswordVisibility]="passwordInput"
            class="input-suffix-button"
            type="button">
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div layout="row" layout-align="space-between center">
        @if (!showForgotPassword) {
          <button type="submit" mat-raised-button>
            {{ 'global.login' | translate }}
          </button>
        }
        @if (showForgotPassword) {
          <button
            (click)="sendPasswordResetEmail($event)"
            mat-raised-button
            >
            {{ 'global.send' | translate }}
          </button>
        }

        <button
          type="button"
          mat-button
          (click)="onForgotPasswordClick()"
          style="margin-top: 10px"
          >
          {{ 'auth.forgottenPassword' | translate }}
        </button>
      </div>
    </form>

    <!-- Password Manager Suggestion Card -->
    @if (showPasswordManagerSuggestion) {
      <div class="password-manager-suggestion">
        <mat-icon class="suggestion-icon">security</mat-icon>
        <span class="suggestion-text">{{
          'auth.passwordManagerSuggestion' | translate
        }}</span>
        <a
          href="https://itfgroup.atlassian.net/wiki/external/N2FjMDE4YjU1ZDIwNDc4YWIwNTU4NmE4ZjE0MmNjZWU"
          target="_blank"
          class="suggestion-link"
          >
          {{ 'auth.learnMore' | translate }}
        </a>
      </div>
    }

    <itfg-message
      [opened]="loginErrored"
      label="{{ 'global.error' | translate }}"
      sublabel="{{ 'auth.invalidCredentials' | translate }}"
      type="error"
    ></itfg-message>
